import styled from "styled-components";

export const BookingModal = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  width: 70%;
  height: 100%;
  background-color: #fff;
  z-index: 10000;
  overflow-y: auto;
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease-in-out;
  transform: translateX(0);

  @media (max-width: 768px) {
    width: 100%; /* Full screen on small devices */
  }
`;